<template>
    <Editable
        :tooltip="tooltip"
        :save-trigger="saveTrigger"
        :help="help"
        :large="large"
        close-on-clickaway
        @start-editing="startEditing"
        @save="save"
    >

        <template #input>
            <b-form-input
                ref="input"
                v-model="value_"
                size="sm"
                :type="type"
                @keydown.enter.native="triggerSave"
            />
        </template>

        <template #preview>
            <slot />
        </template>

    </Editable>
</template>

<script>
import numeral from 'numeral';
import { evaluate } from 'mathjs';
import Editable from '@/components/Editable';

export default {

    components: {
        Editable,
    },

    props: {
        tooltip: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number],
            required: true,
        },
        type: {
            type: String,
            default: 'text',
        },
        format: {
            type: Boolean,
            default: false,
        },
        help: {
            type: String,
            default: '',
        },
        large: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            value_: '',
            saveTrigger: false,
        };
    },

    methods: {
        startEditing() {
            this.value_ = this.value;
            setTimeout(() => {
                this.$refs.input.select();
            }, 100);
        },
        save({ done }) {
            this.$emit('save', {
                value: this.getValue(),
                isDirty: this.value_ !== this.value,
                done,
            });
        },
        /**
         * This is a way of communicating with the Editable component and is a bit of a hack.
         * We change the value of a boolean and watch for the change in the Editable component.
         */
        triggerSave() {
            this.saveTrigger = !this.saveTrigger;
        },
        getValue() {
            return this.format && !this.value_.includes('%') ? numeral(evaluate(this.value_)).value() : this.value_
        },
    },

};
</script>
 
